export abstract class ContactContextBehaviour {
  abstract isContactModeFieldVisible(): boolean;
  abstract isLicenseFieldVisible(): boolean;

  abstract isLocationTypeFieldVisible(): boolean;
  abstract getCriteriaComponentForConsole(): React.ReactNode;

  abstract isCriteriaFieldVisible(): boolean;
  abstract isDescriptionFieldVisible(): boolean;
  abstract showAccessCriteriaAsReadOnly(): boolean;
  abstract showCancelButton(): boolean;
}

export abstract class ContactModeForm {}

export class LeadCaptureCotactMode extends ContactModeForm {}
export class AccessAndAttendanceContactMode extends ContactModeForm {}
